require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-parkview-apartments-are-now-complete.json") })
        }
      }, "path---news-parkview-apartments-are-now-complete");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-parkview-apartments-are-now-complete!./.cache/json/news-parkview-apartments-are-now-complete.json
// module id = 841
// module chunks = 231608221292675